import React, { useEffect } from 'react'
import $ from "jquery";
import "magnific-popup"


const MovieDetail = () => {
  useEffect(() => {

    $('.popup-video').magnificPopup({
      type: 'iframe'
    });
  }, [])
  return (
    <section className="movie-details-area" style={{ backgroundImage: 'url("../img/bg/movie_details_bg.jpg")' }}>
      <div className="container">
        <div className="row align-items-center position-relative">
          <div className="col-xl-3 col-lg-4">
            <div className="movie-details-img">
              <img src="img/events/Workshop_1.png" alt="" />
              <a href="https://www.youtube.com/watch?v=AvgNyz_Ir9A" className="popup-video"><img src="img/images/play_icon.png" alt="" /></a>
            </div>
          </div>
          <div className="col-xl-6 col-lg-8">
            <div className="movie-details-content">
              <h5>New Events</h5>
              <h2>Acting<span> Workshop</span></h2>
              <div className="banner-meta">
                <ul>

                  <li className="release-time">
                    <span><i className="far fa-calendar-alt" /> Starting September, 2025</span>
                    <span><i className="far fa-clock" /> 2 Hours on WEEKENDS</span>
                  </li>
                </ul>
              </div>
              <br/>
              <br/>
              <h3>About Our Instructors</h3>
              <br/><br/>
              <section class="profile">
  <h4>Vivek Sharma</h4>
  <p>
    Vivek Sharma is an actor with over 15 years of extensive experience in Theatre.
    He is the Co-Founder of SatRang Theatre Group in Canada. He recently acted in
    the feature film <em>Animal</em> with T-Series, starring Ranbir Kapoor and
    Rashmika Mandanna, where he played the character Paali. He also acted in
    <em>The Wedding Guest</em>, directed by Michael Winterbottom and starring
    Dev Patel and Radhika Apte. He has extensive experience in production and
    casting, including working as a casting associate for the Netflix web series
    <em>Yeh Kaali Kaali Ankhein</em> and the feature film <em>Bhaag Milkha Bhaag</em>.
  </p>

  <h5>IMDb Links:</h5>
  <ul>
    <li>
      <a href="https://m.imdb.com/name/nm14351193/" target="_blank" rel="noopener noreferrer">
        Vivek Sharma — IMDb
      </a>
    </li>
  </ul>

  <h5>Instagram Link</h5>
  <ul>
    <li>
      <a
        href="https://www.instagram.com/viveksharmabhardwaj?igsh=MXYwNWJzZWZxODFxZQ%3D%3D&utm_source=qr"
        target="_blank"
        rel="noopener noreferrer"
      >
        Vivek Sharma — Instagram
      </a>
    </li>
  </ul>
  <br/><br/><br/><br/>
</section>              <section class="profile">
  <h4>Gurbir Singh Grewal</h4>
  <p>
Gurbir Singh Grewal immigrated to Canada in 2017 and is a Canadian citizen. He has a Post
Graduate Diploma in Cinema from the Film & TV Institute of India, Pune. He has written and
directed many feature films like : Mannat ( starring Jimmy Shergill , Kulraj Randhawa),
Coffee House ( Starting Ashutosh Rana) , Yaar Pardesi, and Punjabi By Nature, Saadi Wakhri
Hai Shaan and Parvaaz-The Journey ( starring Gulshan Grover). He has written more than
10 TV series and directed more than 15 TV series in Punjabi, Hindi, Urdu, and English,
including Neem Ka Ped ( starring Pankaj Kapor) and Eho Hamara Jeevna. He has taught
cinema to Masters in Journalism students as a part-time faculty member at Aligarh Muslim
University from 2000-2009 and 2012-2014. He was also a full-time faculty member and
Joint Director of Cinema at Asian Academy of Film & Television. He is one of the founding
members of SatRang Media & Productions. His upcoming project with SatRang Media &
Productions as writer & director is “ Return Ticket” .
  </p>

  <h5>IMDb Links:</h5>
  <ul>
    <li>
      <a href="https://m.imdb.com/name/nm2430523" target="_blank" rel="noopener noreferrer">
        Gurbir Singh Grewal — IMDb
      </a>
    </li>
  </ul>

  <h5>Instagram Link</h5>
  <ul>
    <li>
      <a
        href="https://www.instagram.com/gurbir1210?igsh=MTd3enhwZTV1cWlsZA=="
        target="_blank"
        rel="noopener noreferrer"
      >
        Gurbir Singh Grewal — Instagram
      </a>
    </li>
  </ul>
</section>
<br/><br/><br/><br/>
            <section class="profile">
  <h4>Sunny ( Sandeep Chahal)</h4>
  <p>
Sunny is a Brampton-based comedian who moved to Canada at age 14 from Punjab, India.
He is the founder of Laalbutton. He has independently studied improv, acting, music, and
dance, including long and short-form improv. Sunny has adapted his knowledge of improv
from English to Punjabi and Hindi to cater to Brampton's unique demographic. He has
taught these workshops as drop-ins with Satrang and the Punjabi Arts Association. He had a
role on the web series “Late Bloomer” starring Jasmeet Raina.
  </p>

  <h5>IMDb Links:</h5>
  <ul>
    <li>
      <a href="https://m.imdb.com/name/nm11283893/" target="_blank" rel="noopener noreferrer">
        Sandeep Chahal — IMDb
      </a>
    </li>
  </ul>

  <h5>Instagram Link</h5>
  <ul>
    <li>
      <a
        href="https://www.instagram.com/sunnydiwanaa?igsh=MW54ZHlhOTk2bnpnZA=="
        target="_blank"
        rel="noopener noreferrer"
      >
        Sandeep Chahal — Instagram
      </a>
    </li>
  </ul>
</section>



            </div>
          </div>
          <div className="movie-details-btn">
            <a href="https://docs.google.com/forms/d/1HJOqb9oLBA0LAZ1I21DQpwyVK8_Od
gzb3dj6r2Y-f3g/edit?usp=drivesdk" className="download-btn" download>Registration<img src="fonts/download.svg" alt="" /></a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MovieDetail